import * as React from 'react';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardList = ({
  children,
  inlineSize
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      inlineSize: inlineSize || '100%',
      maxInlineSize: "50rem",
      rowGap: '600',
      children: React.Children.map(children, (child, index) => {
        var _key;
        return /*#__PURE__*/_jsx(Box, {
          basis: "100%",
          shrink: 0,
          children: child
        }, (_key = child === null || child === void 0 ? void 0 : child.key) !== null && _key !== void 0 ? _key : index);
      })
    })
  });
};